import {getHoursAndMinutesFromTime} from 'platform/components';

import {parseDate} from 'shared/web';

export const castTimeToDateISOString = (date: string, time: string) => {
  const parsedDate = parseDate(date);
  const parsedTime = getHoursAndMinutesFromTime(time);

  if (!parsedTime) {
    return parsedDate.toISOString();
  }

  const {hour, minute} = parsedTime;
  parsedDate.setHours(Number(hour)); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  parsedDate.setMinutes(Number(minute)); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return parsedDate.toISOString();
};
